import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '@ridango/core';
import Env from '@ridango/core/env';

@Injectable()
export class PersonalizedGuard implements CanActivate {
    constructor(
        private authService: AuthService,
        @Inject('ENV') private env: Env
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return !this.authService.getAccountPersonalizationState() && this.env?.ACCOUNT?.PERSONALIZATION_ENABLED;
    }
}
